import { render, staticRenderFns } from "./contentDescription.vue?vue&type=template&id=6fb955e7&scoped=true"
import script from "./contentDescription.vue?vue&type=script&lang=js"
export * from "./contentDescription.vue?vue&type=script&lang=js"
import style0 from "./contentDescription.vue?vue&type=style&index=0&id=6fb955e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb955e7",
  null
  
)

export default component.exports